import React from 'react'

const Header = ({ className, children }) => (
  <header className={className}>
    {children}
  </header>
)

export default Header
